export default "__VITE_ASSET__BceUjiqz__"